import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Logo } from "assets/svg";
import { UserTypeEnum } from "common/enums/UserType.enum";

const LinkInvalid: React.FC = () => {
  const [searchParams] = useSearchParams();
  const typeParam = searchParams.get("type");
  const typeNum = Number(typeParam);
  const registerPath =
    typeNum === UserTypeEnum.COMPANY_SELLER
      ? "/seller/register"
      : typeNum === UserTypeEnum.COMPANY_BUYER
        ? "/buyer/register"
        : "/seller/register";

  return (
    <main className="bg--blur box">
      <div
        className="w-full relative rounded-[20px] border-[8px] border-white bg-primary-light shadow-[0_0_15px_0_rgba(0,0,0,0.05)] flex flex-col items-center justify-center py-[52px] px-[22px]
        sm:max-w-[580px] sm:py-[72px] sm:px-[62px]"
      >
        <Logo
          className="flex justify-center items-center w-[200px] h-[81px] aspect-[1/1] mb-[30px]
             sm:w-[300px] sm:h-[121px] sm:mb-[40px]"
        />
        <h2
          className="text-[22px] not-italic font-bold text-primary mb-[15px]
        sm:text-[28px]"
        >
          リンクが無効です
        </h2>
        <p className="text-[15px] sm:text-[16px] font-normal leading-[160%] text-center mb-[10px]">
          このリンクはすでに使用されたか <br />
          有効期限（24時間）を過ぎているため、
          <br />
          無効になっています。
        </p>
        <p className="text-[15px] sm:text-[16px] font-normal leading-[160%] text-center mb-[30px] sm:mb-[40px]">
          お手数ですが、
          <br />
          もう一度メールアドレスの入力から <br />
          仮登録をお願いいたします。
          <br />
        </p>

        <Link
          to={registerPath}
          className="w-full py-[10px] px-[20px] font-bold bg-primary text-white rounded-[6px] mb-[15px] sm:max-w-[340px] sm:text-[18px] sm:mb-[20px] text-center"
        >
          メールアドレスを再登録する
        </Link>
      </div>
    </main>
  );
};

export default LinkInvalid;
